export const GET_PAYMENT_INFO_REQUEST = 'profile/GET_PAYMENT_INFO_REQUEST';
export const GET_PAYMENT_INFO_FAILURE = 'profile/GET_PAYMENT_INFO_FAILURE';
export const GET_PAYMENT_INFO_SUCCESS = 'profile/GET_PAYMENT_INFO_SUCCESS';

export const SAVE_PAYMENT_INFO_REQUEST = 'profile/SAVE_PAYMENT_INFO_REQUEST';
export const SAVE_PAYMENT_INFO_FAILURE = 'profile/SAVE_PAYMENT_INFO_FAILURE';
export const SAVE_PAYMENT_INFO_SUCCESS = 'profile/SAVE_PAYMENT_INFO_SUCCESS';



// WEBPACK FOOTER //
// ./src/containers/PaymentInfo/constants.js